import Vue from 'vue';
export default Vue.extend({
    name: 'CommonButton',
    props: {
        label: {
            type: String,
            required: true
        },
        ariaLabel: {
            type: String,
            required: false
        },
        color: {
            type: String,
            validator: (v) => ['primary', 'primary-white', 'secondary'].includes(v),
            default: 'primary'
        },
        icon: {
            type: String
        },
        inverseIconPosition: {
            type: Boolean,
            default: false
        },
        iconSpin: {
            type: Boolean,
            default: false
        },
        link: {
            type: String
        },
        width: {
            type: String,
            validator: (v) => ['full'].includes(v),
            required: false
        },
        id: {
            type: String,
            required: false
        }
    },
    setup(props, context) {
        const onClick = () => context.emit('clickEvent');
        const iconClass = () => (props.inverseIconPosition ? 'icon--left' : 'icon--right');
        return { onClick, iconClass };
    }
});
